import React from 'react';
import styles from './Footer.module.css';
import FooterCoins from './FooterCoins';

/**
 * Footer Component
 * Modern footer with company info, links, currencies, and social media
 * Based on old HelloFooter but with fresh design using JACKOPOT design system
 */

const awards = [
  {
    title: 'Best on Mobile',
    organization: 'Sigma Africa',
    year: '2024',
    image: '/assets/images/bcgames/awards/a1.webp'
  },
  {
    title: 'Best Casino Operator',
    organization: 'Sigma Europe',
    year: '2023',
    image: '/assets/images/bcgames/awards/a2.webp'
  },
  {
    title: 'Crypto Game Platform',
    organization: 'Sigma Asia',
    year: '2023',
    image: '/assets/images/bcgames/awards/a1.webp'
  },
  {
    title: 'Crypto Casino',
    organization: 'Sigma Europe',
    year: '2022',
    image: '/assets/images/bcgames/awards/a3.webp'
  },
  {
    title: 'Crypto Casino',
    organization: 'Sigma Africa',
    year: '2022',
    image: '/assets/images/bcgames/awards/a4.webp'
  },
  {
    title: 'Blockchain Gaming',
    organization: 'Platform America',
    year: '2022',
    image: '/assets/images/bcgames/awards/a5.webp'
  },
  {
    title: 'Crypto Casino',
    organization: 'Affpapa',
    year: '2022',
    image: '/assets/images/bcgames/awards/a6.webp'
  },
  {
    title: 'Crypto Casino',
    organization: 'Sigma Europe',
    year: '2022',
    image: '/assets/images/bcgames/awards/a7.webp'
  }
];

const logos = [
  // Logos from /assets/images/logos (copied from old codebase)
  { id: 1, src: '/assets/images/logos/p1.webp', alt: 'Sigma', width: 100, height: 40 },
  { id: 2, src: '/assets/images/logos/p2.webp', alt: 'Responsible Gambling', width: 100, height: 60 },
  { id: 3, src: '/assets/images/logos/p3.webp', alt: 'GamCare', width: 100, height: 90 },
  { id: 4, src: '/assets/images/logos/p4.webp', alt: 'Betblocker', width: 150, height: 50 },
  { id: 5, src: '/assets/images/logos/p5.webp', alt: '18+', width: 50, height: 50 },
  { id: 6, src: '/assets/images/logos/p6.webp', alt: 'Cloud9', width: 130, height: 45 },
];

const socialLinks = [
  { src: "/assets/images/svg/facebook.svg", alt: "Facebook", href: "https://www.facebook.com/share/16p8Fq3wXw/?mibextid=wwXIfr", name: "Facebook" },
  { src: "/assets/images/svg/insta.svg", alt: "Instagram", href: "http://instagram.com/", name: "Instagram" },
  { src: "/assets/images/svg/telegram.svg", alt: "Jackopot.com", href: "https://t.me/jackopot", name: "Jackopot.com" },
  { src: "/assets/images/svg/telegram.svg", alt: "Jackopot sports", href: "https://t.me/jackopotsports", name: "Jackopot Sports" },
  // { src: "/assets/images/svg/telegram.svg", alt: "Jackopot announcement", href: "https://t.me/JackopotAnnouncement", name: "Announcements" },
  // { src: "/assets/images/svg/telegram.svg", alt: "Jackopot Giveaway", href: "https://t.me/jackopotGiveaway", name: "Giveaways" },
];

const currencies = [
  { src: "/assets/images/coins/BTC.webp", alt: "Bitcoin" },
  { src: "/assets/images/coins/ETH.webp", alt: "Ethereum" },
  { src: "/assets/images/coins/DOGE.webp", alt: "Dogecoin" },
  { src: "/assets/images/coins/USDT.webp", alt: "Tether" },
  { src: "/assets/images/coins/LTC.webp", alt: "Litecoin" },
];

const paymentLogos = [
  { src: "/assets/images/coins/BTC.webp", alt: "Bitcoin" },
  { src: "/assets/images/coins/ETH.webp", alt: "Ethereum" },
  { src: "/assets/images/coins/LTC.webp", alt: "Litecoin" },
  { src: "/assets/images/coins/USDT.webp", alt: "Tether" },
  { src: "/assets/images/coins/XRP.webp", alt: "XRP" },
  { src: "/assets/images/coins/DOGE.webp", alt: "Dogecoin" },
  { src: "/assets/images/coins/BCH.webp", alt: "Bitcoin Cash" },
  { src: "/assets/images/coins/ADA.webp", alt: "Cardano" },
  { src: "/assets/images/coins/TRON.webp", alt: "Tron" },
  { src: "/assets/images/coins/TETHER.webp", alt: "Tether" },
];

const Footer = () => {
  return (
    <footer className={styles.footer}>

        {/* Payment Methods Slider */}
        <div className={styles.paymentSlider}>
          <div className={styles.sliderTrack}>
            {[...paymentLogos, ...paymentLogos].map((logo, index) => (
              <img
                key={`logo-${index}`}
                src={logo.src}
                alt={logo.alt}
                className={styles.paymentIcon}
              />
            ))}
          </div>
        </div>
      <div className={styles.container}>
        {/* Partner Logos */}
        <div className={styles.logoSection}>
          <div className={styles.divider}></div>
          <div className={styles.logoContainer}>
            <div className={styles.logoWrapper}>
              {logos.map((logo) => (
                <div 
                  key={logo.id} 
                  className={styles.logoItem}
                  style={{ width: `${logo.width}px`, height: `${logo.height}px` }}
                >
                  <img 
                    src={logo.src} 
                    alt={logo.alt}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className={styles.divider}></div>
        </div>

        {/* Main Footer Content */}
        <div className={styles.footerContent}>
          {/* Company Info Section */}
          <div className={styles.section}>
            <img 
              src="/assets/images/logo/web-logo.webp" 
              alt="Jackopot" 
              className={styles.logo}
            />
            <div className={styles.description}>
              <strong>Jackopot</strong> The Most Trusted and Award-Winning Gaming Platform.
              <br/>
              Step into next-level online gaming with jackopot, where innovation meets excitement! Explore thousands of games, including E-sports, Live Casino, Slots, Crash, HashDice, Plinko, and more. Bet on live sports, enjoy instant withdrawals, and claim unbeatable bonuses – all in one place.
              <br/>
              Join thousands of players who trust jackopot for a secure, fair, and thrilling gaming experience – whether you play with crypto or fiat currency.
              <br/>
              By using jackopot, you confirm that you've read and agree to our <a href='/provably-fair'><strong>Terms of Service</strong></a> and <a href='/provably-fair'><strong>Responsible Gaming Policy</strong></a>.
              <br/>
              <strong>Please note:</strong> Cryptocurrency trading is not classified as gambling and therefore falls outside the scope of our gaming license
            </div>
          </div>

          {/* Quick Links Section */}
          <div className={styles.section}>
            <h3 className={styles.linkHeader}>Quick Links</h3>
            <div className={styles.linkWrapper}>
              <a href="/provably-fair" className={styles.link}>Help Center</a>
              <a href="/provably-fair" className={styles.link}>User Agreement</a>
              <a href="/provably-fair" className={styles.link}>Privacy Policy</a>
              <a href="/provably-fair" className={styles.link}>Responsible Gaming</a>
            </div>
            <h3 className={styles.linkHeader}>Contact Us</h3>
            <a href="mailto:admin@Jackopot.com" className={styles.link}>
              Email: <span className={styles.emailHighlight}>admin@Jackopot.com</span>
            </a>
          </div>

          {/* Currencies & Social Section */}
          <div className={styles.section}>
            {/* <h3 className={styles.linkHeader}>Accepted Currencies</h3> */}
            {/* <div className={styles.currencyContainer}>
              {currencies.map((currency, index) => (
                <img
                  key={index}
                  src={currency.src}
                  alt={currency.alt}
                  className={styles.currencyIcon}
                />
              ))}
            </div> */}
            <h3 className={styles.linkHeader} style={{ marginTop: '25px' }}>Follow Us</h3>
            
            <div className={styles.socialRow}>
              <div className={styles.socialColumn}>
                <h4 className={styles.socialTitle}>Social Media</h4>
                <div className={styles.iconContainer}>
                  {socialLinks.slice(0, 2).map((social, index) => (
                    <a
                      key={index}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.socialLink}
                    >
                      <img src={social.src} alt={social.alt} className={styles.socialIcon} />
                      <span className={styles.socialText}>{social.name}</span>
                    </a>
                  ))}
                </div>
              </div>
              
              <div className={styles.socialColumn}>
                <h4 className={styles.socialTitle}>Telegram links</h4>
                <div className={styles.iconContainer}>
                  {socialLinks.slice(2, 6).map((social, index) => (
                    <a
                      key={index}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.socialLink}
                    >
                      <img src={social.src} alt={social.alt} className={styles.socialIcon} />
                      <span className={styles.socialText}>{social.name}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

     
        {/* <FooterCoins /> */}
        


        {/* Note Section */}
        <div className={styles.noteSection}>
          <p className={styles.noteText}>
            This website offers gaming with risk experience. To be a user of our site you must be <strong>over 18 years old</strong>. 
            We are not responsible for the violation of your local laws related to i-gaming. 
            <strong> Play responsibly and have fun on Jackopot.</strong>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
